module.exports = __webpack_public_path__ + "img/deluxe-vehicle-filter-welcome-background-mitsu.3c142226.png";